export const AUTH_REWARD_CODE_ATTR = 'custom:rewardCode'
export const AUTH_FIRST_NAME_ATTR = 'given_name'
export const AUTH_LAST_NAME_ATTR = 'family_name'
export const AUTH_TERMS_ACCEPTED_ATTR = 'custom:termsAccepted'
